import React from 'react';
import {
    FormControlLabel,
    Checkbox,
    Typography,
    Link as MuiLink,
    Box,
} from '@mui/material';

interface TermsAndConditionsCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    required?: boolean;
    showRequiredMessage?: boolean;
    sx?: any;
}

export const TermsAndConditionsCheckbox: React.FC<
    TermsAndConditionsCheckboxProps
> = ({
    checked,
    onChange,
    disabled = false,
    required = false,
    showRequiredMessage = false,
    sx,
}) => {
    return (
        <Box sx={sx}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={checked}
                        onChange={e => onChange(e.target.checked)}
                        name="termsAccepted"
                        color="primary"
                        size="small"
                        disabled={disabled}
                    />
                }
                label={
                    <Typography variant="body2">
                        I accept the{' '}
                        <MuiLink
                            href="https://cropwestinsurance.com/sla/"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()}
                        >
                            terms and conditions
                        </MuiLink>
                        .
                    </Typography>
                }
                sx={{ alignSelf: 'flex-start' }}
            />

            <Typography
                variant="caption"
                display="block"
                sx={{
                    mt: 0.5,
                    mb: showRequiredMessage ? 0.5 : 1,
                    color: 'warning.main',
                    fontWeight: 500,
                    fontSize: '0.75rem',
                }}
            >
                You must accept the terms and conditions.
            </Typography>
        </Box>
    );
};
